import { required, minLength, maxLength, choices, email } from "react-admin";

export const validateName = [required(), minLength(3), maxLength(40)];
export const validateUsername = [required(), minLength(3), maxLength(20)];
export const validatePassword = [required(), minLength(8), maxLength(15)];
export const validateNumber = [required(), minLength(9), maxLength(13)];
export const validateRoles = [required()];
export const validateEmail = email();
